// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bab99b13","667":"2d0f20f0","977":"de277907"}[chunkId] + ".chunk.js";
};